import { INSERT_UPDATE_DELEGATE_ITINERARY_ACTION_TYPE, GET_DELEGATE_ITINERARY_LIST_ACTION_TYPE, GET_DELEGATE_ITINERARY_DETAILS_ACTION_TYPE,VERIFY_DELEGATE_ITINERARY_TIMESLOT_ACTION_TYPE,GET_DELEGATE_B2B_CHECKED_SCHEDULE_ACTION_TYPE } from "../../../utils/constants"


const initialState = [];

function delegate_ItineraryReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case INSERT_UPDATE_DELEGATE_ITINERARY_ACTION_TYPE:
            return [...state, payload];
        case GET_DELEGATE_ITINERARY_LIST_ACTION_TYPE:
            return [...state, payload];
        case GET_DELEGATE_ITINERARY_DETAILS_ACTION_TYPE:
            return [...state, payload];
        case VERIFY_DELEGATE_ITINERARY_TIMESLOT_ACTION_TYPE:
            return [...state, payload];
        case GET_DELEGATE_B2B_CHECKED_SCHEDULE_ACTION_TYPE:
            return [...state, payload];

        default:
            return state;
    }
};

export default delegate_ItineraryReducer;